import { useLoading } from "../../../modules/shared/helpers/loading-provider.helper";

export default function LoadingOverlay() {
  const { loading } = useLoading();
  if (!loading) return null;

  return (
    <div className="loading-overlay">
      <div className="spinner-wrapper">
        <div className="gradient-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
      </div>

      <style>{`
        .loading-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, 0.85);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          transition: opacity 0.4s ease;
        }

        .spinner-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 120px;
          height: 120px;
        }

        .gradient-spinner {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .spinner-ring {
          position: absolute;
          border-radius: 50%;
          border: 4px solid transparent;
          border-top-color: #E55921;
          border-bottom-color: #E55921;
          animation: spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
          will-change: transform;
        }

        .spinner-ring:nth-child(1) {
          width: 100%;
          height: 100%;
          animation-duration: 1.2s;
        }

        .spinner-ring:nth-child(2) {
          width: 70%;
          height: 70%;
          animation-duration: 1.8s;
          border-top-color: #000000;
          border-bottom-color: #000000;
          opacity: 0.6;
        }

        .spinner-ring:nth-child(3) {
          width: 40%;
          height: 40%;
          animation-duration: 2.4s;
          border-top-color: #E55921;
          border-bottom-color: #E55921;
          opacity: 0.4;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        /* Glow effect behind spinner */
        .spinner-wrapper::after {
          content: '';
          position: absolute;
          width: 180px;
          height: 180px;
          background: radial-gradient(circle, rgba(229, 89, 33, 0.15) 0%, transparent 70%);
          border-radius: 50%;
          animation: pulse-glow 2.4s ease-in-out infinite;
          pointer-events: none;
          will-change: transform, opacity;
        }

        @keyframes pulse-glow {
          0%, 100% { transform: scale(1); opacity: 0.6; }
          50% { transform: scale(1.2); opacity: 1; }
        }

        /* Optional subtle pulse on the whole overlay */
        .loading-overlay {
          animation: fade-in 0.3s ease;
        }

        @keyframes fade-in {
          0% { opacity: 0; }
          100% { opacity: 1; }
        }

        /* Reduced motion preference */
        @media (prefers-reduced-motion: reduce) {
          .spinner-ring {
            animation-duration: 2s !important;
          }
          .spinner-wrapper::after {
            animation: none;
          }
        }
      `}</style>
    </div>
  );
}
